<template>
  <div>
    <el-form>
      <el-row>
        <el-col span="6">
          <el-form-item label="sensoryTemplate 导入">
            <el-upload :multiple="true" :action="uploadSensoryTemplateUrl" :headers="headers">
              <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
            </el-upload>
          </el-form-item>
        </el-col>
        <el-col span="6">
          <el-form-item label="sensoryTemplate导出sensoryReport">
            <el-button type="primary" icon="el-icon-search" @click="exportSensoryReport">导出</el-button>
          </el-form-item>
        </el-col>
        <el-col span="6">
          <el-form-item label="sensoryReport导入">
            <el-upload :multiple="true" :action="uploadSensoryReportUrl" :headers="headers">
              <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
            </el-upload>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col span="12">
          <el-form-item label="msv 导入">
            <el-upload :multiple="true" :action="uploadMsvUrl" :headers="headers">
              <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
            </el-upload>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col span="12">
          <el-form-item label="line 导入">
            <el-upload :multiple="true" :action="uploadLineUrl" :headers="headers">
              <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
            </el-upload>
          </el-form-item>
        </el-col>
        <el-col span="12">
          <el-form-item label="lint to product">
            <el-upload :multiple="true" :action="lineToProductUrl" :headers="headers" :http-request="reportDetailDocUpload">
              <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
            </el-upload>
          </el-form-item>
        </el-col>
        <el-col span="12">
          <el-form-item label="productFright导入">
            <el-upload :multiple="true" :action="importProductFreightUrl" :headers="headers">
              <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
            </el-upload>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="feedback 导入">
            <el-upload :multiple="true" :action="uploadFeedbackUrl" :headers="headers">
              <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
            </el-upload>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col span="6">
          <el-form-item label="物料报价申请单 导入">
            <el-upload :multiple="true" :action="uploadProductApply" :headers="headers">
              <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
            </el-upload>
          </el-form-item>
        </el-col>
        <el-col span="6">
          <el-form-item label="物料报价 导入">
            <el-upload :multiple="true" :action="uploadProductPrice" :headers="headers">
              <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
            </el-upload>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col span="6">
          <el-form-item label="导出全部流程">
            <el-button type="primary" @click="exportWorkflow">导出全部流程</el-button>
          </el-form-item>
        </el-col>
        <el-col span="6">
          <el-form-item label="流程导入">
            <el-upload :multiple="true" :action="uploadActivitiWorkFlow" :headers="headers">
              <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
            </el-upload>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col span="6">
          <el-form-item label="上传至服务器">
            <el-input v-model="fileType"></el-input>
            {{uploadRes}}
            <el-upload :multiple="true" :on-success="showRes" :action="uploadToDfs" :headers="headers">
              <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
            </el-upload>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-card>
          <div slot="header">
            <p>{{hostName}}logs<el-button size="mini" type="primary" icon="el-icon-refresh" circle @click="reloadLogs"></el-button></p>
          </div>
          <div>
            <ul>
              <li v-for="log in logs">
                <el-link @click="downloadLog(log.fileName)">{{`${log.fileName}(${log.fileSize})`}}</el-link>
              </li>
            </ul>
          </div>
        </el-card>
      </el-row>
    </el-form>
    <el-row></el-row>
    <el-button type="primary" icon="el-icon-search" @click="exportPdf">Test</el-button>
    <el-button type="primary" @click="refreshCache">Refresh Cache</el-button>
  </div>
</template>

<script>
import { testData } from "../../api";
import { exportExcel } from "@/api/sensory/template";
import commonFun from "@/utils/commonFun";
import request from "@/utils/request";
import { fileService } from "@/api/common/file-utils";
import commonConstants from "@/constants/commonConstants";
import { Message } from "element-ui";

export default {
  computed: {
    uploadSensoryTemplateUrl: function () {
      return commonConstants.baseUrl + "sensory-template/import"
    },
    uploadSensoryReportUrl: function () {
      return commonConstants.baseUrl + "sensory-report/importHistory"
    },
    uploadLineUrl: function () {
      return commonConstants.baseUrl + "line/import"
    },
    lineToProductUrl: function () {
      return commonConstants.baseUrl + "line/toProduct"
    },
    importProductFreightUrl: function () {
      return commonConstants.baseUrl + "product-freights/importProductFreight"
    },
    uploadFeedbackUrl: function () {
      return commonConstants.baseUrl + "feedbacks/historyImport"
    },
    uploadProductPrice: function () {
      return commonConstants.baseUrl + "dataImport/importProductQuotation"
    },
    uploadActivitiWorkFlow: function () {
      return commonConstants.baseUrl + "activiti/service/models/import"
    },
    uploadToDfs: function () {
      return commonConstants.baseUrl + `file/${this.fileType}`;
    },
    uploadProductApply: function () {
      return commonConstants.baseUrl + "dataImport/importProductQuotationApply"
    },
    uploadMsvUrl: function () {
      return commonConstants.baseUrl + "msv/importHistory"
    },
    headers: function () {
      return {
        "x-access-token": localStorage.getItem('token')
      }
    }
  },
  data: () => {
    return {
      logs: [],
      fileType: "s3",
      uploadRes: "",
      hostName: '',
    }
  },
  methods: {
    reloadLogs: function () {
      request({
        url: "logs",
        method: 'get',
      }).then((data) => {
        this.logs = data.data.logs;
        this.hostName = data.data.hostName;
      });
    },
    showRes: function (res) {
      this.uploadRes = res;
    },
    exportWorkflow: function () {
      request({
        url: `activiti/service/models/export`,
        method: 'get',
        responseType: 'blob',
        fullResponse: true
      }).then((resp) => fileService.respToFile(resp));
    },
    downloadLog: function (fileName) {
      request({
        url: `logs/${fileName}`,
        method: 'get',
        responseType: 'blob',
        fullResponse: true
      }).then((resp) => fileService.respToFile(resp, fileName));
    },
    reportDetailDocUpload: function (item) {
      let _this = this;
      let formData = new FormData();
      formData.append("file", item.file);
      request({
        url: "line/toProduct",
        method: 'POST',
        data: formData,
        responseType: 'blob',
        fullResponse: true
      }).then(fileService.respToFile);
    },
    lineToProductSuccess() {
      console.error(arguments);
      let resp = {
        data: arguments[0],
        headers: {
          "content-disposition": "attachment;filename=%E4%BA%A7%E5%93%81%E4%BB%B7%E6%A0%BC.xlsx"
        }
      }
      fileService.respToFile(resp, "a.xlsx");
    },
    getData() {
      // testData().then((res)=>{
      // });
      request({
        url: `/localLogin/test`,
        method: 'post',
        headers: {
          'Content-Type': 'application/json; charset=UTF-8'
        },
        responseType: 'blob',
        fullResponse: true,
      }).then(resp => {
        fileService.respToFile(resp);
      });
    },
    exportSensoryReport() {
      request({
        url: `/sensory-template/exportReport`,
        method: 'get',
        responseType: 'blob',
        fullResponse: true,
      }).then(resp => {
        fileService.respToFile(resp);
      });
    },
    refreshCache() {
      return request({
        url: `/base-data/refreshCache`,
        method: 'post',
      }).then(res => {
        Message.success(res);
      });
    },
    importSensoryReport() {
      request({
        url: `/sensory-template/exportReport`,
        method: 'get',
        responseType: 'blob',
        fullResponse: true,
      }).then(resp => {
        fileService.respToFile(resp);
      });
    }
  }

}
</script>
